import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Input } from "../components/ui/input";
import { Field } from "../components/booking/StepFields";
import { ClawMark, Wordmark } from "../components/site/Brand";
import { api, apiError } from "../lib/api";
import { fieldCls } from "../lib/pricing";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data?.token) localStorage.setItem("pt_admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(apiError(err, "Não foi possível entrar."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen grid place-items-center px-5 py-16 bg-[radial-gradient(ellipse_50%_40%_at_50%_0%,rgba(255,210,0,0.12),transparent)]">
      <form onSubmit={submit} data-testid="admin-login-modal" className="w-full max-w-md rounded-[28px] border border-white/10 bg-[#111219] p-8 sm:p-10 space-y-6">
        <Link to="/" className="flex items-center gap-2"><ClawMark /><Wordmark /></Link>
        <div>
          <h1 className="font-display font-black text-2xl uppercase text-white">Painel administrativo</h1>
          <p className="text-sm text-zinc-400 mt-1">Acesso restrito à equipe Play Toys.</p>
        </div>
        <Field label="E-mail">
          <Input data-testid="admin-login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={fieldCls} />
        </Field>
        <Field label="Senha">
          <Input data-testid="admin-login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={fieldCls} />
        </Field>
        {error && <p data-testid="admin-login-error" className="text-sm text-[#FF6B6B]">{error}</p>}
        <button type="submit" disabled={loading} data-testid="admin-login-submit"
          className="w-full inline-flex justify-center items-center gap-2 rounded-full bg-[#FFD200] text-[#08080C] font-semibold py-4 hover:bg-white transition-colors disabled:opacity-60">
          {loading && <Loader2 className="w-4 h-4 animate-spin" />} Entrar
        </button>
      </form>
    </main>
  );
}
